var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseSidenav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#909090"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.608 20.2032C18.8041 20.4012 18.9141 20.6686 18.9141 20.9472C18.9141 21.2259 18.8041 21.4933 18.608 21.6913C18.5117 21.7891 18.397 21.8667 18.2704 21.9197C18.1438 21.9727 18.008 22 17.8708 22C17.7336 22 17.5977 21.9727 17.4712 21.9197C17.3446 21.8667 17.2298 21.7891 17.1336 21.6913L11.3058 15.7448C11.11 15.5464 11.0002 15.2788 11.0002 15C11.0002 14.7212 11.11 14.4536 11.3058 14.2552L17.1336 8.30868C17.2298 8.21092 17.3446 8.13328 17.4712 8.08028C17.5977 8.02729 17.7336 8 17.8708 8C18.008 8 18.1438 8.02729 18.2704 8.08028C18.397 8.13328 18.5117 8.21092 18.608 8.30868C18.8041 8.50669 18.9141 8.77409 18.9141 9.05275C18.9141 9.33141 18.8041 9.59881 18.608 9.79682L13.8286 15.0023L18.608 20.2032Z",
    fill: "#FFD822"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseSidenav);
export default __webpack_public_path__ + "static/media/CollapseSidenav.5f693aa26e3e2ec7ae5a37c9e0ac73d4.svg";
export { ForwardRef as ReactComponent };